import * as React from "react";
import { useState } from "react";
import HelpBlock from "components/bootstrap/HelpBlock";
import MarkdownEditorModal from "components/common/MarkdownEditor/EditorModal";
const helpBlock = /* @__PURE__ */ React.createElement(HelpBlock, null, "You can add additional notes here, which will be appended to the notes of all events you have selected.");
const AddNotesModal = ({ closeModal, onConfirm, show = false }) => {
  const [notes, setNotes] = useState("");
  return show ? /* @__PURE__ */ React.createElement(
    MarkdownEditorModal,
    {
      value: notes,
      show,
      onChange: setNotes,
      onClose: closeModal,
      onDone: onConfirm,
      helpBlock
    }
  ) : null;
};
export default AddNotesModal;
